/* eslint-disable no-useless-escape */
/* eslint-disable no-nested-ternary */
import classNames from 'classnames';
import {
  Link, useLocation, useParams, useSearchParams,
} from 'react-router-dom';
import { actions as certificationActions } from 'Slice/CertificationSlice';
import { selectData } from 'Selector/CertificationSelector';
import { useDispatch, useSelector } from 'react-redux';
import {
  getQueryPersonId, isElement, isGuestfromEmail, isGuest, scrollToElementWhenReady, valueToObject,
} from 'Utils/UtilityFunctions';
import {
  selectCompanyDetailFlurry, selectCompanyDetailsCall,
} from 'Selector/CompaniesSelector';
import { actions as flurryActions } from 'Slice/HelperSlice';
import { actions as UiAction } from 'Slice/UISlice';
import { selectDisclessPersonality } from 'Selector/GlobalSearchContentSelector';
import { APP_USAGE, APP_USAGE_LINK } from 'Utils/Constants';
import SkeletonCustom from '../skeleton/SkeletonCustom';
import OpenInNewTab from '../assets/svgIcons/OpenInNewTab';
import PromotionIcon from '../assets/svgIcons/Promotionicon';
import { Popover } from 'antd';
import { useEffect, useState } from 'react';
import { IsMobile } from '../../../Utils/UtilityFunctions';

type Props = {
  tabsName?: object,
  baseComponentPath?: string,
  headerAppendTab?: boolean,
  elementTarget?: string,
  loading?: boolean,
  isActive?: boolean,
  removeSearch?: boolean,
  fromPersonTab?: boolean,
  scrollStartToWindow?: boolean,
  fromFeedTab?: boolean,
  companyActiveTab?: string
  feedActiveTab?: string
  personActiveTab?: string
  blip?: boolean,
  strategicHighlightsIconProp?: boolean,
  currentSection?: any,
} & typeof defaultProps;

const defaultProps = {
  tabsName: ['Account Activity'],
  baseComponentPath: 'feed',
  headerAppendTab: false,
  elementTarget: '',
  loading: false,
  isActive: false,
  removeSearch: false,
  fromPersonTab: false,
  scrollStartToWindow: false,
  fromFeedTab: false,
  companyActiveTab: '',
  feedActiveTab: '',
  personActiveTab: '',
  currentSection: [],
};

type Params = {
  section: string
};

const FeedTabs = function FeedTabs(props: Props) {
  const {
    tabsName, baseComponentPath,
    headerAppendTab, elementTarget, loading, isActive,
    removeSearch, fromPersonTab, scrollStartToWindow, fromFeedTab, companyActiveTab,
    feedActiveTab, personActiveTab, strategicHighlightsIconProp, currentSection
  } = props;
  const { section } = useParams<Params>();
  const [searchParams] = useSearchParams();
  const groupId = searchParams.get('groupId');
  const location = useLocation();
  const { search, pathname } = location;
  const data = useSelector(selectData);
  const disclessPersonality = useSelector(selectDisclessPersonality);
  const dispatch = useDispatch();
  const host = window.location.href;
  const flurryObject = useSelector(selectCompanyDetailFlurry);
  const isCalled = useSelector(selectCompanyDetailsCall);
  const [strategicHighlightsIcon, setStrategicHighlightsIcon] = useState(strategicHighlightsIconProp);
  const isMobile = IsMobile();
  const isGuestUser = isGuest() || isGuestfromEmail();

  const pathGenerator = (value: string): string => {
    let searchParam = search.replace(/[\?&]scroll=true(&|$)/g, '');
    searchParam = search.replace(/[\?&]fromNewsTab=true(&|$)/g, '');
    let personTabFix = '';
    if (value.toLowerCase().trim().replace(/ /g, '') === 'xiqinsights' || value.toLowerCase() === 'about') {
      personTabFix = 'personalityinsights';
    } else {
      personTabFix = value.toLowerCase().trim().replace(/ /g, '');
    }
    const key = `/${baseComponentPath}/${personTabFix}${removeSearch ? '' : searchParam}`;
    return key;
  };

  const isActiveInCaseNameChange = (item: string) => {
    if (((item === 'xiqinsights' && personActiveTab !== 'Strategic Highlights') || item === 'about') && section === 'personalityinsights') {
      return true;
    }
    return false;
  };

  const getEventName = (tabName: string) => {
    const tab = tabName.toLowerCase();
    if (baseComponentPath.includes('person')) {
      switch (tab) {
        case 'xiq insights':
          return 'person_insights';
        case 'about':
          return 'person_insights';
        case 'personal':
          return 'person_personal';
        case 'career':
          return 'person_career';
        case 'videos':
          return 'person_videos';
        case 'news':
          return 'person_news';
        default:
          return 'person_insights';
      }
    }
    if (baseComponentPath.includes('company')) {
      switch (tab) {
        case 'news':
          return 'company_sales';
        case 'sales triggers':
          return 'company_sales';
        case 'staff':
          return 'company_staff';
        case 'financials':
          return 'company_financials';
        case 'videos':
          return 'company_videos';
        case 'details':
          return 'company_details';
        case 'competitors':
          return 'company_competitor';
        case 'benefits':
          return 'company_benefits';
        default:
          return 'company_sales';
      }
    }
    return '';
  };

  const scrollTabInView = (item: string, position: boolean) => () => {
    const tabName = item.toLowerCase();
    if (tabName === 'benefits') {
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('benefits_tab_click', 0, {
          ...flurryObject,
        }),
      ));
    }
    if (tabName === 'financials') {
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('financials_tab_click', 0, {
          ...flurryObject,
        }),
      ));
    }
    if (tabName === 'news' && baseComponentPath.includes('feed')) {
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('salesTrigger_tab_clicked', 0, {
          host,
        }),
      ));
    }
    if (tabName === 'spotlight') {
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('spotlight_tab_clicked', 0, {
          host,
        }),
      ));
    }
    dispatch(UiAction.isShowGilroyGlobalToggle(false));
    if (headerAppendTab) {
      const id = item.toLowerCase() === 'news' && !fromPersonTab && !fromFeedTab
        ? 'trigger-details'
        : elementTarget;
      const scrollTargetId = item === 'Spotlight' || item === 'spotlight' ? 'certification-spotlight' : id;

      if (position || item === 'xiQ insights' || item.toLowerCase() === 'about' || item.toLowerCase() === 'overview') {
        window.scrollTo(0, 0);
      } else if (item === 'Gilroy' || item === 'gilroy') {
        requestAnimationFrame(() => {
          const eleGill = document.querySelector('.App') as HTMLElement;
          isElement(eleGill, 0);
        });
      } else {
        const offset = item === 'Spotlight' || item === 'spotlight' ? -150 : -120;
        scrollToElementWhenReady(scrollTargetId, offset);
      }
    }
    if (baseComponentPath.includes('person')) {
      if (tabName === 'news') {
        dispatch(flurryActions.callFlurryEvent(
          valueToObject('executive_news', 0, {
            host,
            person_id: getQueryPersonId(),
            type: 'Executive'
          }),
        ));
      }
      dispatch(certificationActions.certificationAction({
        type: getEventName(item || 'xiq insights'),
        source: 'person',
        data,
      }));
    }
    if (baseComponentPath.includes('company')) {
      dispatch(certificationActions.certificationAction({
        type: getEventName(item || 'triggers'),
        source: 'company',
        data,
      }));

      if (item.toLowerCase() === 'swot') {
        dispatch(flurryActions.callFlurryEvent(
          valueToObject('companypage_swot_click', 0, {
            ...flurryObject,
            ...isCalled && { isCalled },
          }),
        ));
      }
    }
    if (baseComponentPath.includes('groupdetails')) {
      if (item === 'Highlights') {
        dispatch(certificationActions.certificationAction({
          type: 'highlights_tab',
          source: 'buyer',
          data,
        }));
        dispatch(flurryActions.callFlurryEvent(
          valueToObject('buyer_group_highlights_tab_clicked', 0, {
            ...groupId && { group_id: groupId },
            host,
          }),
        ));
      }
      if (item === 'Members') {
        dispatch(flurryActions.callFlurryEvent(
          valueToObject('buyer_group_members_tab_clicked', 0, {
            ...groupId && { group_id: groupId },
            host,
          }),
        ));
      }
    }
    if (tabName === 'strategichighlights') {
      setStrategicHighlightsIcon(false);
    }
  };
  useEffect(() => {
    setStrategicHighlightsIcon(strategicHighlightsIconProp);
  }, [strategicHighlightsIconProp]);

  const Content = () => (
    <div className="strategic-popover-content">
      Explore New Feature by clicking on it
    </div>
  );
  return (
    <span className="tabs-wrapper">
      {loading ? [1, 2, 3, 4].map(() => (
        <SkeletonCustom
          height="30px"
          width="80px"
          diameter="8px"
          margin="0px 8px 0px 0px"
        />
      )) : tabsName.map((item: string, key: number) => {
        if ((item === 'Overview' || item === 'SWOT' || item === 'Sales Triggers' || item === 'Strategic Highlights') && baseComponentPath.includes('company')) {
          const name = item.toLowerCase().replace(/[ .]/g, '');
          const isPath = pathname.includes('overview') || pathname.includes('news') || pathname.includes('strategichighlights');
          return (

            <Link
              key={item}
              to={pathGenerator(name === 'salestriggers' ? 'news' : name)}
              role="button"
              tabIndex={0}
              onClick={scrollTabInView((name === 'salestriggers' ? 'news' : name), scrollStartToWindow)}
              onContextMenu={(e) => {
                e.preventDefault();
                return false;
              }}
              className={classNames(`tabs-item ${item === 'Strategic Highlights' ? 'promotion-tab' : ''}`, {
                active: ((item === companyActiveTab && isPath) || (name === 'swot' && pathname.includes('swot'))),
              })}
              area-label={key}
              replace
            >
              {(strategicHighlightsIcon) && !isGuestUser && (
                <Popover
                  placement="bottom"
                  content={<Content />}
                  getPopupContainer={(e: HTMLElement) => e}
                  arrow={false}
                >
                  <span className='promotion-icon'>{item === 'Strategic Highlights' && <PromotionIcon />}</span>
                </Popover>
              )
              }
              {item.toLowerCase() === 'news' ? fromPersonTab ? 'News' : 'Sales Triggers' : item.toLowerCase() === 'swot' ? 'SWOT Analysis' : item}
            </Link>
          );
        }
        if (item === 'Strategic Highlights' && baseComponentPath.includes('person')) {
          const name = item.toLowerCase().replace(/[ .]/g, '');
          return (
            <Link
              key={item}
              to={pathGenerator(name)}
              role="button"
              tabIndex={0}
              onClick={scrollTabInView(name, scrollStartToWindow)}
              onContextMenu={(e) => {
                e.preventDefault();
                return false;
              }}
              className={classNames('tabs-item promotion-tab', {
                active: (item.toLowerCase().trim().replace(/ /g, '') === section || currentSection.includes('Strategic Highlights') || isActive || isActiveInCaseNameChange(item.toLowerCase().trim().replace(/ /g, ''))),
              })}
              area-label={key}
              replace
            >
              {strategicHighlightsIcon && (
                <Popover
                  placement="bottom"
                  content={!isMobile ? <Content /> : null}
                  getPopupContainer={(e: HTMLElement) => e}
                  arrow={false}
                >
                  <span className='promotion-icon'><PromotionIcon /></span>
                </Popover>
              )}
              {item}
            </Link>
          );
        }
        if (baseComponentPath.includes('feed')) {
          const name = item.toLowerCase().replace(/[ .]/g, '');
          return (

            <Link
              key={item}
              to={pathGenerator(name === 'salestriggers' ? 'news' : name)}
              role="button"
              tabIndex={0}
              onClick={scrollTabInView((name === 'salestriggers' ? 'news' : name), scrollStartToWindow)}
              onContextMenu={(e) => {
                e.preventDefault();
                return false;
              }}
              className={classNames('tabs-item', {
                active: ((item === feedActiveTab)),
              })}
              area-label={key}
              replace
            >
              {item.toLowerCase() === 'news' ? fromPersonTab ? 'News' : 'Sales Triggers' : item.toLowerCase() === 'swot' ? 'SWOT Analysis' : item}
            </Link>
          );
        }
        if (item === APP_USAGE) {
          return (
            <Link
              key={item}
              to={APP_USAGE_LINK}
              role="button"
              tabIndex={0}
              onContextMenu={(e) => {
                e.preventDefault();
                return false;
              }}
              className={classNames('tabs-item')}
              area-label={key}
              replace
              target="_blank"
              rel="noopener noreferrer"
            >
              {item}
              <OpenInNewTab />
            </Link>
          );
        }
        return (
          <Link
            key={item}
            to={pathGenerator(item)}
            role="button"
            tabIndex={0}
            onClick={scrollTabInView(item, scrollStartToWindow)}
            onContextMenu={(e) => {
              e.preventDefault();
              return false;
            }}
            className={classNames('tabs-item', {
              active: (item.toLowerCase().trim().replace(/ /g, '') === section || isActive || isActiveInCaseNameChange(item.toLowerCase().trim().replace(/ /g, ''))),
            })}
            area-label={key}
            replace
          >
            {item.toLowerCase() === 'news' ? fromPersonTab ? 'News' : 'Sales Triggers' : item.toLowerCase() === 'swot' ? 'SWOT Analysis' : baseComponentPath.includes('person') && disclessPersonality && item.toLowerCase() === 'about' ? 'Gilroy' : item}
          </Link>
        );
      })}
    </span >
  );
};

FeedTabs.defaultProps = defaultProps;
export default FeedTabs;
